<div class="orders-container">
  <!-- Tabs -->
  <div class="tabs-container">
    <div *ngFor="let tab of tabs" 
         class="tab" 
         [class.active]="tab === activeTab"
         (click)="onTabChange(tab)">
      {{ tab }}
    </div>
  </div>

  <!-- Content Container -->
  <div class="content-container">
    <h2 class="tab-heading">{{ activeTab }}</h2>
    
    <!-- Table -->
    <div class="table-container">
      <table>
        <thead>
          <tr>
            <th *ngFor="let column of tableColumns" [style.width]="column.width">
              {{ column.name }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let order of selectedOrders" (click)="showResponse(order)">
            <td *ngFor="let column of tableColumns">
              {{ getCellValue(order, column.name) }}
            </td>
          </tr>
          <tr *ngIf="selectedOrders.length === 0">
            <td [attr.colspan]="tableColumns.length" class="no-data">
              No orders selected
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Order Button -->
    <button *ngIf="showOrderButton" 
            class="order-button"
            (click)="onOrderClick()">
      Order
    </button>
  </div>
</div>

<!-- Orders Popup -->
<div class="pop-up-wrapper">
    <app-orders-popup
    [orderList]="orderList" 
    [currentCaseDay]="currentCaseDay"
    [currentCaseTime]="currentCaseTime"
    [selectedOrderIds]="selectedOrderIds"
    [cancelledOrders]="cancelledOrders"
    *ngIf="showPopup"
    (close)="onPopupClose()"
    (confirmOrders)="onOrdersConfirm($event)"
  ></app-orders-popup>
</div>

<!-- End Case Confirmation Dialog -->
<div class="confirmation-dialog-overlay" *ngIf="showCancelOrderConfirmation">
  <div class="confirmation-dialog">
    <div class="confirmation-content">
      <h3>Cancel Order</h3>
      <p>Are you sure you want to cancel this order? </p>
      <div class="confirmation-actions">
        <button class="btn-stop" (click)="closeCancelOrderConfirmation()">No</button>
        <button class="btn-continue" (click)="cancelOrder()">Yes</button>
      </div>
    </div>
  </div>
</div>

<!-- Prerequisite Order Cancellation Confirmation Dialog -->
<div class="confirmation-dialog-overlay" *ngIf="showPrerequisiteCancelConfirmation">
  <div class="confirmation-dialog cancelpre">
    <div class="confirmation-content">
      <h3>Cancel Prerequisite Order</h3>
      <p>{{ prerequisiteCancelMessage }}</p>
      <div class="confirmation-actions">
        <button class="btn-stop" (click)="closePrerequisiteCancelConfirmation()">No</button>
        <button class="btn-continue" (click)="cancelPrerequisiteOrder()">Yes</button>
      </div>
    </div>
  </div>
</div> 